// import VT from '@/store/types';

export default {
  // [VT.SAMPLE_LABEL_SETS_LIST]: (state, { data, status }) => {
  //   state.sampleLabelSetsList = { data, status };
  // },
};
